import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

import { NotificationConfig, NotificationType } from '../models/notification-config';
import { AddNewNotificationAction, DismissNotificationAction } from '../state/notifications.actions';
import { Notification } from '../state/notifications.interface';
import { NotificationsState } from '../state/notifications.reducer';
import { getAllNotifications, getVisibleNotifications, getVisibleNotificationsByChannel } from '../state/notifications.selector';

@Injectable({
	providedIn: 'root'
})
export class NotificationsService {

	constructor(private store: Store<NotificationsState>, private contentService: ContentService) { }

	public addNotification(config: NotificationConfig): Notification {
		const notification: Notification = {
			channel: null,
			duration: null,
			icon: null,
			isDismissed: false,
			type: NotificationType.CONFIRMATION,
			timestamp: Date.now(),
			id: uuidv4(),
			...config
		};
		this.store.dispatch(new AddNewNotificationAction(notification));
		return notification;
	}

	public dismissNotification(id: string): void {
		this.store.dispatch(new DismissNotificationAction(id));
	}

	public getAllNotifications$(): Observable<Notification[]> {
		return this.store.pipe(select(getAllNotifications));
	}

	public getAllVisibleNotifications$(): Observable<Notification[]> {
		return this.store.pipe(select(getVisibleNotifications));
	}

	public getVisibleNotificationsByChannel$(channels: string[]): Observable<Notification[]> {
		return this.store.pipe(select(getVisibleNotificationsByChannel(channels)));
	}

	// This function adds notifications based on the channel, message and notification type dcr keys provided.
	public setupNotificationsFromDcr(messageKey: string, typeKey: string, channel: string): Notification {
		const notificationMessage = this.contentService.get(messageKey, null);
		const notificationType = this.contentService.get(typeKey, NotificationType.WARNING).toUpperCase();
		if (notificationMessage && notificationType && notificationType in NotificationType) {
			return this.addNotification({ channel: channel, message: notificationMessage, type: notificationType as NotificationType });
		}
	}
}
